import { useState, useEffect } from "react"

export type SearchKey = "dec" | "hex" | "oct" | "bin" | "htmlUri" | "htmlUriComponent" | "char" | "htmlEntity"

export type SearchFilter = {
  [x in SearchKey]?: string
}

export type SearchField = {
  key: SearchKey
  label: string
}
const searchFields: SearchField[] = [
  { key: "char", label: "Character", },
  { key: "dec", label: "Decimal", },
  { key: "hex", label: "Hex", },
  { key: "oct", label: "Octal", },
  { key: "bin", label: "Binary", },
  { key: "htmlUri", label: "HTML URI", },
  { key: "htmlUriComponent", label: "HTML URI Component", },
  { key: "htmlEntity", label: "HTML Entity", },
]

type AsciiSearchProps = {
  onChange: (searchFilter: SearchFilter) => void
}
export function AsciiSearch({ onChange }: AsciiSearchProps) {
  const [searchFilter, setSearchFilter] = useState<SearchFilter>({})

  useEffect(() => {
    onChange(searchFilter)
  }, [searchFilter, onChange])

  return <div className="">
    <table className="w-full table-fixed">
      <thead>
        <tr>
          {searchFields.map(field =>
            <th key={field.key}>
              <input type="text"
                className="border w-full"
                placeholder={field.label}
                onChange={e => setSearchFilter({ [field.key]: e.target.value })}
                value={searchFilter[field.key] || ""}
              />
            </th>
          )}
        </tr>
      </thead>
    </table>
  </div>
}